import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import {
  getFirestore,
  collection,
  getDocs,
  query,
  where,
  updateDoc,
  doc,
  orderBy
} from "firebase/firestore";
import { app } from "../firebase";
import { LuList } from "react-icons/lu";

const auth = getAuth(app);
const db = getFirestore(app);

/* ===================== ESTILOS (PADRÃO FATURAMENTO) ===================== */

const Main = styled.main`
 flex: 1;
 padding: 2rem 4rem;
 background: #f3f7ff;
 min-height: 100vh;
 display: flex; flex-direction: column; gap: 1.25rem;

 @media (max-width: 1280px){ padding: 2rem; }
 @media (max-width: 768px){ padding: 1rem; }
`;

const FilterWrapper = styled.div`
 margin-bottom: 1rem;
 display: flex;
 align-items: center;
 gap: .75rem;
 flex-wrap: wrap;

 @media (max-width: 768px) {
 gap: .5rem;
 }
`;

const Select = styled.select`
 padding: 0.6rem 0.75rem;
 border-radius: 0.75rem;
 border: 1px solid #ccc;
 font-size: 1rem;
  color: #1F1A40;
 background-color: #fff;

 @media (max-width: 768px) {
  width: 100%;
  font-size: .95rem;
  padding: .55rem .7rem;
 }
`;

const Label = styled.label`
 font-size: 1rem;
 color: #1F1A40;
 display: flex;
 align-items: center;
 gap: .5rem;

 @media (max-width: 768px) {
  width: 100%;
  font-size: .95rem;
  flex-direction: column;
  align-items: flex-start;
  gap: .4rem;
 }
`;

const Card = styled.section`
 background: #fff; border: 1px solid #e6ecf5; border-radius: 1rem;
 box-shadow: 0 6px 20px rgba(58,121,237,.06);
`;
const CardHeader = styled.div`
 display:flex; align-items:center; gap:.6rem;
 padding: 1rem 1.1rem; border-bottom: 1px solid #eef2fb; color: #1f1a40; font-weight: 700;
 svg{ color:#3a79ed; }
`;
const CardBody = styled.div`
 padding: 1rem 1.1rem; display:flex; flex-direction:column; gap:.9rem;
`;

// ===================== ESTILOS DA TABELA (AJUSTADOS) =====================

const TableContainer = styled.div`
 max-height: 70vh;
 overflow: auto;
 border-radius: 1rem;
 border: 1px solid #eef2fb; /* Borda leve como no Faturamento */
 background: white;
 box-shadow: 0 6px 20px rgba(58,121,237,.06);

 @media (max-width: 768px) {
  max-height: none;
  overflow: auto;
 }
`;

const Table = styled.table`
 width: 100%;
 border-collapse: collapse;
 background: white;
 border-radius: 1rem; /* Borda arredondada */
 overflow: hidden;
 font-size: 0.9rem; /* Padrão do Faturamento */
 text-align: left;

 @media (max-width: 768px) {
  min-width: 720px;
 }
`;

// Th ajustado para usar as cores de fundo claro do Faturamento
const Th = styled.th`
 text-align: left;
 padding: 0.75rem 1rem; /* Padrão do Faturamento */
 background: #f8fbff; /* Fundo claro */
 color: #5b6478; /* Texto cinza escuro */
 font-weight: 700; /* Negrito */
 text-transform: uppercase;
 border-bottom: 2px solid #eef2fb;
 position: sticky;
 top: 0;
 z-index: 1;

 @media (max-width: 768px) {
  padding: 0.75rem 1rem;
  font-size: .85rem;
 }
`;

// Td ajustado para usar as cores do Faturamento
const Td = styled.td`
 padding: 0.75rem 1rem; /* Padrão do Faturamento */
 border-bottom: 1px solid #f0f0f0;
 color: #334155; /* Texto padrão */
 font-size: 0.95rem;
 white-space: nowrap;

 @media (max-width: 768px) {
  padding: 0.75rem 1rem;
  font-size: .9rem;
 }
`;

// NOVO: Componente Status para usar o estilo 'pill/badge'
const StatusBadge = styled.span`
 font-weight: 600;
 padding: 0.2rem 0.6rem;
 border-radius: 0.5rem;
 font-size: 0.8rem;
 text-transform: capitalize;
 /* Cores baseadas em confirmado/cancelado */
 color: ${({ status }) => status === "confirmado" ? '#065f46' : '#9a3412'};
 background: ${({ status }) => status === "confirmado" ? '#d1fae5' : '#fee2e2'};
`;

// StatusButton ajustado para ser o padrão azul (confirmar) ou vermelho (cancelar)
const StatusButton = styled.button`
 background-color: ${({ status }) => (status === "cancelado" ? "#3a79ed" : "#b42318")};
 color: white;
 border: none;
 border-radius: 8px;
 padding: 6px 10px;
 font-size: 0.85rem;
 cursor: pointer;
 font-weight: 600;
 width: 100px;
 transition: background-color 0.2s;

 &:hover {
  background-color: ${({ status }) => (status === "cancelado" ? "#2f65c7" : "#8d1f1f")};
 }
 &:disabled {
  background-color: #ccc;
  cursor: default;
 }

 @media (max-width: 768px) {
  width: auto;
  font-size: .8rem;
  padding: 6px 10px;
 }
`;

/* REMOVIDO: StatusCircle não é mais usado, substituído por StatusBadge */


/* ===================== COMPONENTE ===================== */
export default function Detalhamento() {
  const [barbeariaId, setBarbeariaId] = useState(null);
  const [agendamentos, setAgendamentos] = useState([]);
  const [barbeiros, setBarbeiros] = useState([]);
  const [filtroBarbeiro, setFiltroBarbeiro] = useState("todos");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) return;
      const q = query(collection(db, "barbearia"), where("criadorUid", "==", user.uid));
      const snap = await getDocs(q);
      if (!snap.empty) {
        const id = snap.docs[0].id;
        setBarbeariaId(id);
        await carregarBarbeiros(id);
        await carregarAgendamentos(id);
      }
      setLoading(false);
    });
    return () => unsub();
  }, []);

  const carregarAgendamentos = async (id) => {
    const qy = query(
      collection(db, `barbearia/${id}/agendamentos`),
      orderBy("criadoEm", "desc")
    );
    const snap = await getDocs(qy);
    const lista = snap.docs.map(docu => {
      const data = docu.data();
      return { id: docu.id, ...data, status: data.status || "confirmado" };
    });
    setAgendamentos(lista);
  };

  const carregarBarbeiros = async (id) => {
    const snap = await getDocs(collection(db, `barbearia/${id}/barbeiros`));
    const lista = snap.docs.map(docu => ({ id: docu.id, nome: docu.data().nome }));
    setBarbeiros(lista);
  };

  const alterarStatusAgendamento = async (agendamentoId, novoStatus) => {
    if (!barbeariaId || !agendamentoId) return;
    const confirmar = window.confirm(
      `Deseja ${novoStatus === "cancelado" ? "cancelar" : "confirmar"} este agendamento?`
    );
    if (!confirmar) return;
    await updateDoc(doc(db, `barbearia/${barbeariaId}/agendamentos/${agendamentoId}`), {
      status: novoStatus
    });
    await carregarAgendamentos(barbeariaId);
  };

  const agendamentosFiltrados =
    filtroBarbeiro === "todos"
      ? agendamentos
      : agendamentos.filter(a => a.barbeiroId === filtroBarbeiro);

  // Caso loading
  if (loading) return <Main>Carregando Agendamentos...</Main>;

  return (
    <>
      <Main>
        <Card>
          <CardHeader><LuList />Agendamentos</CardHeader>
          <CardBody>
            <FilterWrapper>
              <Label>
                Filtrar por barbeiro:
                <Select
                  value={filtroBarbeiro}
                  onChange={(e) => setFiltroBarbeiro(e.target.value)}
                >
                  <option value="todos">Todos</option>
                  {barbeiros.map(b => (
                    <option key={b.id} value={b.id}>{b.nome}</option>
                  ))}
                </Select>
              </Label>
            </FilterWrapper>

            <TableContainer>
              <Table>
                <thead>
                  <tr>
                    <Th>Cliente</Th>
                    <Th>Telefone</Th>
                    <Th>Serviço</Th>
                    <Th>Barbeiro</Th>
                    <Th>Data</Th>
                    <Th>Hora</Th>
                    <Th>Status</Th>
                    <Th>Ação</Th>
                  </tr>
                </thead>
                <tbody>
                  {agendamentosFiltrados.map(a => (
                    <tr key={a.id}>
                      <Td>{a.clienteNome}</Td>
                      <Td>{a.clienteTelefone}</Td>
                      <Td>{a.servicoNome}</Td>
                      <Td>{a.barbeiroNome}</Td>
                      <Td>{a.data}</Td>
                      <Td>{a.horaInicio}</Td>
                      <Td>
                        <StatusBadge status={a.status}>
                          {a.status === "confirmado" ? "Confirmado" : "Cancelado"}
                        </StatusBadge>
                      </Td>
                      <Td>
                        <StatusButton
                          status={a.status}
                          onClick={() =>
                            alterarStatusAgendamento(
                              a.id,
                              a.status === "cancelado" ? "confirmado" : "cancelado"
                            )
                          }
                        >
                          {a.status === "cancelado" ? "Confirmar" : "Cancelar"}
                        </StatusButton>
                      </Td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </TableContainer>
          </CardBody>
        </Card>
      </Main>
    </>
  );
}